<template>
    <div class="hello">
      <h1>about view</h1>
    <draggable 
      v-model="myArray" 
      group="people" 
      @start="drag=true" 
      @end="drag=false" 
      item-key="id">
  <template #item="{element}">
    <div>
        <span>{{element.name}}</span>
        <span>{{element.name}}</span>
    </div>
   </template>
</draggable>
                
    </div>
  </template>
  
  <script>
import draggable from 'vuedraggable'
  export default {
    name: 'HelloWorld',
    props: {
      msg: String
    },
    components: {
        draggable,
    },
    data() {
      return {
        drag: false,
       myArray: [
        {
          "name": "John",
          "id": 0
        },
        {
          "name": "Joao",
          "id": 1
        },
        {
          "name": "Jean",
          "id": 2
        }
      ]
      }
    },
     component:{
      // "vue3-slider": slider,
      draggable,
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only --> 
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  </style>
  